import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const CreateCurrencyModal = ({ isOpen, onClose, onSave, currency }) => {
  const { t } = useTranslation();

  // State for form fields
  const [name, setName] = useState("");
  const [symbol, setSymbol] = useState("");
  const [code, setCode] = useState("");
  const [exchangeRateToUsd, setExchangeRateToUsd] = useState("");
  const [isDefault, setIsDefault] = useState(false);

  // Populate fields when the modal is opened for an update
  useEffect(() => {
    if (currency) {
      setName(currency.name || "");
      setSymbol(currency.symbol || "");
      setCode(currency.code || "");
      setExchangeRateToUsd(currency.exchange_rate_to_usd || "");
      setIsDefault(currency.is_default || false);
    } else {
      // Clear fields when creating a new currency
      setName("");
      setSymbol("");
      setCode("");
      setExchangeRateToUsd("");
      setIsDefault(false);
    }
  }, [currency]);

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    const currencyData = {
      name,
      symbol,
      code,
      exchange_rate_to_usd: parseFloat(exchangeRateToUsd),
      is_default: isDefault,
    };

    onSave(currencyData);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96">
        <h2 className="text-xl font-bold mb-4">
          {currency ? t("Update Currency") : t("Create Currency")}
        </h2>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <input
            type="text"
            placeholder={t("Name")}
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="border p-2 rounded"
            required
          />
          <input
            type="text"
            placeholder={t("Symbol")}
            value={symbol}
            onChange={(e) => setSymbol(e.target.value)}
            className="border p-2 rounded"
            required
          />
          <input
            type="text"
            placeholder={t("Code")}
            value={code}
            onChange={(e) => setCode(e.target.value)}
            className="border p-2 rounded"
            required
          />
          <input
            type="number"
            placeholder={t("Exchange Rate to USD")}
            value={exchangeRateToUsd}
            onChange={(e) => setExchangeRateToUsd(e.target.value)}
            className="border p-2 rounded"
            required
          />
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={isDefault}
              onChange={(e) => setIsDefault(e.target.checked)}
              className="w-4 h-4"
            />
            {t("set_as_default")}
          </label>
          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-700"
            >
              {t("Cancel")}
            </button>
            <button
              type="submit"
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-700"
            >
              {currency ? t("Update") : t("Create")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateCurrencyModal;